import { isArray } from 'lodash';
import { isTokenValid } from './Auth';
import {
  addItemToBasketAuth,
  getBasketSummaryAuth,
  getDynamicBasket,
  getValidatedBasket,
  updateBasketItemQuantityAuth,
} from '../api/Basket';
import { AddItemToBasketRequest } from '../interfaces/Basket/AddItemToBasketRequest';
import { validatedBasketToAddItemRequest } from '../interfaces/Basket/ValidatedBasket';
import { BasketSummary } from '../interfaces/Basket/BasketSummary';
import { BasketItem } from '../interfaces/Basket/BasketItem';

export const getStoredBasket = (): AddItemToBasketRequest[] => {
  let basket = [];
  try {
    const rawBasket = localStorage.getItem('basket');
    if (rawBasket) {
      basket = JSON.parse(rawBasket);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return isArray(basket) ? basket : [];
};

export const setStoredBasket = (basket: AddItemToBasketRequest[]) =>
  localStorage.setItem('basket', JSON.stringify(basket));

export const clearStoredBasket = () => localStorage.removeItem('basket');

export const addItemToBasket = async (
  req: AddItemToBasketRequest,
): Promise<void> => {
  if (isTokenValid()) {
    return addItemToBasketAuth(req);
  }

  return new Promise<void>((resolve) => {
    const storedBasket = getStoredBasket();
    const index = storedBasket.findIndex(
      (x) =>
        x.productID === req.productID && x.optionValueID === req.optionValueID,
    );
    if (index > -1) {
      storedBasket[index].quantity += req.quantity;
      storedBasket[index].addedAtCheckout = false;
    } else {
      storedBasket.push(req);
    }

    setStoredBasket(storedBasket);

    resolve();
  });
};

export const getBasketSummary = async (
  hasCoupon: boolean,
): Promise<BasketSummary> => {
  if (isTokenValid()) {
    return getBasketSummaryAuth(hasCoupon);
  }

  const storedBasket = getStoredBasket();
  const validatedBasket = await getValidatedBasket(storedBasket);
  const newBasket = validatedBasket.map(validatedBasketToAddItemRequest);
  setStoredBasket(newBasket);

  return getDynamicBasket(newBasket, hasCoupon);
};

export const updateBasketItemQuantity = async (
  basketItem: BasketItem,
  quantity: number,
): Promise<void> => {
  if (isTokenValid()) {
    return updateBasketItemQuantityAuth(basketItem.id, quantity);
  }

  return new Promise<void>((resolve) => {
    const storedBasket = getStoredBasket();
    const index = storedBasket.findIndex(
      (x) =>
        x.productID === basketItem.product.id &&
        x.optionValueID === basketItem.options[0]?.item.optionValueID,
    );
    if (index > -1) {
      if (quantity) {
        storedBasket[index].quantity = quantity;
      } else {
        storedBasket.splice(index, 1);
      }
    }

    setStoredBasket(storedBasket);

    resolve();
  });
};
